/**
 * The time interval, in milliseconds, between the provided date and the current date and time
 *
 * If the date is earlier than the current date and time, this returned value is negative
 *
 * @internal */
export const timeIntervalFromNow = (dateOrTimestamp: Date | number) => {
    const date = typeof dateOrTimestamp === 'number' ? new Date(dateOrTimestamp) : dateOrTimestamp
    const now = new Date()
    return date.getTime() - now.getTime()
}
